<a routerLink="/" target="_blank">
    @if (!appSession.tenant || !appSession.tenant.logoId) {
        <img src="/assets/common/images/app-logo-on-light.svg" alt="logo" height="38" />
    }
    @if (appSession.tenant && appSession.tenant.logoId) {
        <img
            [src]="
                remoteServiceBaseUrl +
                '/TenantCustomization/GetTenantLogo?skin=' +
                currentTheme.baseSettings.menu.asideSkin +
                '&tenantId=' +
                appSession.tenant.id +
                '&id=' +
                appSession.tenant.logoId
            "
            alt="logo"
            height="38"
        />
    }
</a>
